import { useEffect, useState } from "react";

/**
 * The current instant, refreshed every `intervalMs` — so time-gated controls (Mark
 * complete appears at session start, past sessions grey out) change while the page is
 * open, without a reload.
 *
 * @param {number} intervalMs
 * @returns {Date}
 */
export default function useNow(intervalMs = 60000) {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}
